"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const react = require("react");
const useThrottler = require("./useThrottler.cjs");
function useThrottledState(value, options, selector) {
  const [throttledValue, setThrottledValue] = react.useState(value);
  const throttler = useThrottler.useThrottler(setThrottledValue, options, selector);
  return [throttledValue, throttler.maybeExecute, throttler];
}
exports.useThrottledState = useThrottledState;
//# sourceMappingURL=useThrottledState.cjs.map
